var map = {
	"./ativo/modulo-configurador.svg": 1222,
	"./ativo/modulo-financeiro.svg": 3883,
	"./ativo/modulo-gestao-projeto.svg": 182,
	"./ativo/modulo-suporte.svg": 5161,
	"./desativo/modulo-configurador.svg": 7702,
	"./desativo/modulo-financeiro.svg": 9483,
	"./desativo/modulo-gestao-projeto.svg": 4902,
	"./desativo/modulo-suporte.svg": 6889
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4392;